import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup } from "vue"

import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import Button from '@/components_new/Button.vue'
import Icon from '@/components_new/Icon/Icon.vue'
import Link from '@/components_new/Link.vue'
import TasksWidget from '@/components_new/TaskItems/TasksWidget.vue'
import { ROUTE_NAMES } from '@/router/constants'
import { useLayoutStore } from '@/store/layout-store'
import { useUserStore } from '@/store/user-store/user-store'
import { useIsMounted } from '@/utils/vue-hooks/use-is-mounted'

import Search from '../Search/Search.vue'
import HeaderTiles from './components/HeaderTiles.vue'
import LogoutButton from './components/LogoutButton.vue'
import RewardsWidget from './components/RewardsWidget.vue'
import UserWidget from './components/UserWidget.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DesktopHeader',
  setup(__props) {

const layoutStore = useLayoutStore()
const userStore = useUserStore()
const router = useRouter()
const route = useRoute()
const isMounted = useIsMounted()
const isSearchOpened = ref(false)
const isUserProfilePage = computed(() => route.name === ROUTE_NAMES.PROFILE)
const { isAuthorized, isUserInfoLoaded, user, userBalance } = storeToRefs(userStore)

async function logout() {
    await userStore.logout()
    router.replace({ name: ROUTE_NAMES.MAIN })
}

function signin() {
    layoutStore.setSignInModalOpened(true)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(_ctx.$style.header),
    "data-interface-section": "desktop-header"
  }, [
    _createVNode(Link, {
      to: { name: _unref(ROUTE_NAMES).MAIN },
      "data-interface-target": "navigation-link",
      class: _normalizeClass(_ctx.$style.icon_wrapper),
      hoverAnimation: "rainbow"
    }, {
      default: _withCtx(() => [
        _createVNode(Icon, {
          name: "playgama_logo",
          class: _normalizeClass(_ctx.$style.icon_logo)
        }, null, 8, ["class"])
      ]),
      _: 1
    }, 8, ["to", "class"]),
    _createVNode(_TransitionGroup, {
      tag: "div",
      enterFromClass: _ctx.$style.fade_enter_from,
      enterActiveClass: _ctx.$style.fade_enter_active,
      moveClass: _ctx.$style.fade_move,
      leaveActiveClass: _ctx.$style.fade_leave_active,
      leaveToClass: _ctx.$style.fade_leave_to,
      class: _normalizeClass(_ctx.$style.flexible_block)
    }, {
      default: _withCtx(() => [
        _createVNode(Search, {
          key: "search",
          paddingSize: "m",
          inputClass: _ctx.$style.search,
          onOpen: _cache[0] || (_cache[0] = ($event: any) => (isSearchOpened.value = true)),
          onClose: _cache[1] || (_cache[1] = ($event: any) => (isSearchOpened.value = false))
        }, null, 8, ["inputClass"]),
        (!isSearchOpened.value)
          ? (_openBlock(), _createBlock(TasksWidget, {
              key: "tasks",
              class: _normalizeClass(_ctx.$style.widgets_override),
              redirect: ""
            }, null, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(RewardsWidget, { key: "rewards" }),
        (_unref(isUserInfoLoaded) && _unref(isMounted))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(user) && _unref(isAuthorized))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(UserWidget, {
                      key: "user",
                      user: _unref(user),
                      isProfilePage: isUserProfilePage.value,
                      userBalance: _unref(userBalance)
                    }, null, 8, ["user", "isProfilePage", "userBalance"]),
                    (isUserProfilePage.value)
                      ? (_openBlock(), _createBlock(LogoutButton, {
                          key: "logout",
                          onLogout: logout
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createBlock(Button, {
                    key: "signin",
                    size: "xl",
                    interfaceTarget: "open-sign-in-modal",
                    onClick: signin
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$tr('mobileHeader.login')), 1)
                    ]),
                    _: 1
                  }))
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          key: "tiles",
          class: _normalizeClass([_ctx.$style.right_block, isSearchOpened.value && _ctx.$style.desktop_medium_hidden])
        }, [
          _createVNode(HeaderTiles)
        ], 2)
      ]),
      _: 1
    }, 8, ["enterFromClass", "enterActiveClass", "moveClass", "leaveActiveClass", "leaveToClass", "class"])
  ], 2))
}
}

})